import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue/client'
import { configure } from 'vue-gtag'
import './index.css'
import './assets/themes/care.css'
import './assets/themes/talent.css'
import 'cropperjs/dist/cropper.css'
import App from './App.vue'
import router from './router'
import { Toaster } from 'vue-sonner'
import 'vue-sonner/style.css'
import { initSentry } from '@/lib/sentry'
import EchoService from '@/services/EchoService'
import { reloadOnceForChunkError } from '@/lib/chunkReload'

// Vite fires this when a preloaded chunk fails to load (typically after a new
// deploy replaced the hashed assets this tab was built against). Recover with a
// single guarded reload.
window.addEventListener('vite:preloadError', (event) => {
    reloadOnceForChunkError((event as Event & { payload?: unknown }).payload)
})

// Initialize Laravel Echo for real-time broadcasting
EchoService.init()

const app = createApp(App)
const pinia = createPinia()
const head = createHead()

// Initialize Sentry before other plugins
initSentry({ app, router })

app.use(pinia)
app.use(router)
app.use(head)

// Configure Google Analytics
if (import.meta.env.VITE_GA_MEASUREMENT_ID) {
    configure({
        tagId: import.meta.env.VITE_GA_MEASUREMENT_ID,
        config: {
            send_page_view: false
        }
    })
}

app.component('Toaster', Toaster)
app.mount('#app')
